import { useEffect, useState } from "react";

import { Col, Row } from "react-bootstrap";
import NavLinkButton from "../../common/components/NavLinkButton";
import { PALETTE } from "../../common/ThemeConstants";

import IconWorkout from "../../common/images/iconWorkoutActive.png";
import IconProfile from "../../common/images/iconProfileActive.png";
import { useAuth } from "../../auth/hook";

export default function AccountShopCards() {
  const [workouts, setWorkouts] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);
  const auth = useAuth();

  useEffect(() => {
    if (auth.user.workouts) {
      setWorkouts(auth.user.workouts);
    }
    if (auth.user.subscriptions) {
      setSubscriptions(auth.user.subscriptions);
    }
  }, [
    setWorkouts,
    setSubscriptions,
    auth.user.workouts,
    auth.user.subscriptions,
  ]);
  return (
    <>
      <Row>
        <Col>
          <NavLinkButton
            text={
              <>
                <img src={IconWorkout} style={{ width: 30 }} />
                <p style={{ marginBottom: 0, fontSize: 15 }}>
                  <span
                    style={{
                      fontWeight: "bold",
                      color: PALETTE.DARKGRAY,
                    }}
                  >
                    {workouts.length}
                  </span>
                  <span style={{ fontSize: 14, color: PALETTE.DARKGRAY }}>
                    {" Allenamenti"}
                  </span>
                </p>
                <span style={{ fontSize: 12, color: PALETTE.GRAY }}>
                  acquistati
                </span>
              </>
            }
            to={"/account/Account/Workouts"}
            backgroundColor={PALETTE.WHITE}
            color={PALETTE.GRAY}
            backgroundColorHover={PALETTE.GRADIENTLIGHT}
            colorHover={PALETTE.GRAY}
            shadow={true}
          />
        </Col>
        <Col>
          <NavLinkButton
            text={
              <>
                <img src={IconProfile} style={{ width: 30 }} />
                <p style={{ marginBottom: 0, fontSize: 15 }}>
                  <span
                    style={{
                      fontWeight: "bold",
                      color: PALETTE.DARKGRAY,
                    }}
                  >
                    {subscriptions.length}
                  </span>
                  <span style={{ fontSize: 14, color: PALETTE.DARKGRAY }}>
                    {" Abbonamenti"}
                  </span>
                </p>
                <span style={{ fontSize: 12, color: PALETTE.GRAY }}>
                  acquistati
                </span>
              </>
            }
            to={"/account/Account/Subscriptions"}
            backgroundColor={PALETTE.WHITE}
            borderColor={PALETTE.LIGHTGRAY}
            color={PALETTE.SECONDARYCOLORHOVER}
            backgroundColorHover={PALETTE.GRADIENTLIGHT}
            colorHover={PALETTE.GRAY}
            shadow={true}
          />
        </Col>
      </Row>
    </>
  );
}
